import { Component, OnInit } from '@angular/core';
import { BasketService } from '../../services/basket.service';
import { Basket, InterfaceBasketItem } from '../../models/basket';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { StripeService } from 'src/app/services/stripe.service';
import { StreamService } from 'src/app/services/stream.service';
import { TimeZoneService } from "../../services/timezone.service";

@Component({
  selector: 'app-basket',
  templateUrl: './basket.component.html',
  styleUrls: ['./basket.component.scss']
})
export class BasketComponent implements OnInit {
  public basket: Basket;
  public loggedIn: boolean = false;
  finalAmount: number = 1;
  public couponCode:string='';
  public customer;
  public customerLoading:boolean=true;
  public couponMessage:string='';
  public currencySymbol = "£";
  public DefaultTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public basketTotal: number = 1;

  constructor(
    private basketService: BasketService,
    private authService: AuthenticationService,
    private stream: StreamService,
    private router:Router,
    private _stripe:StripeService,
    private timezoneService: TimeZoneService
  ) {
    this.removeDiscount();
    this.getBasket();
    this.loggedIn=this.authService.loggedIn.value;

    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();

    if(!this.DefaultTimeZone || this.EUTimeZone){
      if(this.timezoneService.checkUSATimeZone()) this.currencySymbol = "$";
      else if(this.timezoneService.checkCanadaTimeZone()) this.currencySymbol = "C$";
      else if(this.timezoneService.checkAustraliaTimeZone()) this.currencySymbol = "AUD$";
      else if(this.timezoneService.checkAucklandTimeZone()) this.currencySymbol = "NZ$";
      else if(this.timezoneService.checkHongKongTimeZone()) this.currencySymbol = "HK$";
      else if(this.timezoneService.checkUAETimeZone()) this.currencySymbol = "AED";
      else if(this.EUTimeZone) this.currencySymbol = "€";
    }
  }

  public checkPrice(price)
  {
    if(!this.DefaultTimeZone || this.EUTimeZone) {
      const converted = this.basketService.exchangeCalculator(price);
      return Math.round(converted / 100) * 100;
    }

    return price;
  }

  public getBasket(){
    this.basketService.basket.subscribe(basket => {
      // console.log('new basket', basket);
      this.basket = basket;

      // this.basket.tax = this.basketService.getTax();
      // this.basket.sub_total = this.basketService.getSubTotal();
      this.basket.total = this.basketService.getTotal();
      this.basket.currency = this.basketService.getCurrencyISOCode();

      // for (let item of basket.items) {
      //   item.item.price = 0;
      // }

      // this.basket.discount_value=this.basketService.getDiscount();
      // console.log(this.basket);
    });
  }

  checkout(){
    return this.router.navigate(['/basket/checkout']);
  }

  goToOrder(orderId){
    this.router.navigate(['/account/order-history/order/'+orderId]);
  }

  public getCustomer(){
    this._stripe.getCustomer().subscribe(
      res=>{
        this.customer=res;
        // console.log(this.basket);
        // this.checkDiscounts();
        this.removeDiscount();
        this.customerLoading=false;
      }
    );
  }

  private checkDiscounts(){

    // if(this.customer.discount && this.customer.discount.coupon.valid){
      if(this.basket.discount_amount) {
        if (this.basket.items) {
          // console.log('do this');
        } else {
          this.removeDiscount();
        }
        // if (this.customer.discount.coupon.amount_off) {
        //   this.basketService.addDiscount('amount',this.customer.discount.coupon.amount_off,this.customer.discount.coupon.id);
        // } else {
        //   this.basketService.addDiscount('percent',this.customer.discount.coupon.percent_off,this.customer.discount.coupon.id);
        // }

      }
    // }
  }

  public removeDiscount(){
    this.basketService.removeDiscounts();
    // this.getBasket();
  }

  public applyCoupon(){
    this.couponMessage='';
    this.removeDiscount();
    if(!this.couponCode) return;
    if(!this.basket.items) return;
    let ids=[];
    this.basket.items.forEach(item=>{
      ids.push(item.item.id);
    });
    this.stream.getDiscount(this.couponCode, ids).subscribe(res=>{
      if(res.status=='success'){

// console.log(res.discount);
        if(res.discount.global > 0){
          this.basketService.addDiscount(res.discount.type, res.discount.amount, res.discount.code, 0);
          // this.getBasket();
        } else {
          // console.log('here');
          // console.log(res.discount.stream.stream_id);
          this.basketService.addDiscount(res.discount.type, res.discount.amount, res.discount.code, res.discount.stream.stream_id);

          // console.log(this.basketService.getDiscount());
        }
        // this.getBasket();

      } else {
        this.couponMessage=res.message;
      }
      // console.log(res);
    });

    // this._stripe.applyCoupon(this.couponCode).subscribe(
    //   res=>{
    //     this.getCustomer();
    //   }
    // );

  }

  public clearBasket() {
    this.basketService.clear();
  }

  public changeQuantity(item: InterfaceBasketItem) {
    if (item.quantity < 1 || isNaN(item.quantity)) {
      this.basket.items.filter(items => items.type === item.type && items.item.id === item.item.id).forEach(basketItem => {
        setTimeout(() => {
          basketItem.quantity = 1;
        }, 10);
      });
    }
  }

  public addToBasket(type, recipe, quiet) {
    this.basketService.add(type, recipe, quiet);
  }
  public removeFromBasket(type, recipe, quiet) {
    this.basketService.remove(type, recipe, quiet);
  }

  ngOnInit() {
    this.getCustomer();



  }

}
